<div class="message-container">
  <div class="message-content">
    <div class="message-title">{{ title }}</div>
    <div class="message-body primary">
      {{ text }}
    </div>
  </div>
  <div>
    <button mat-icon-button (click)="snackBarRef.dismiss()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</div>
